import { Box, CircularProgress } from '@mui/material';
import React from 'react';

const Spinner = () => {
  return (
    <Box position="absolute" top="50%" left="50%" data-testid="spinnerTest">
      <CircularProgress />
    </Box>
  );
};

export { Spinner };
